// react imports
import React, { useEffect, useMemo } from 'react';

// react components
import { AuthPageLayout } from './AuthPageLayout';
import { LoginForm } from '../../components/Login/LoginForm';
import { useTranslation } from 'react-i18next';
// imports
import { randomInt } from '../../utils/random';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { useAppDispatch, useAppSelector } from '../../hooks/hooksRedux';
import { fetchStyleGuide, styleGuideSelector } from '../../store/globalSlice/styleSlice';

const LoginPage: React.FunctionComponent = () => {
  const randomImage = useMemo(() => randomInt(1, 5), []);
  const [, setDomain] = useLocalStorage<string | null>('domain', null);
  const dispatch = useAppDispatch();
  const styleGuide = useAppSelector(styleGuideSelector);
  const { t } = useTranslation();
  const logo = styleGuide.data.logo || '/img/new-logo.png';

  useEffect(() => {
    const domain = window.location.hostname;
    if (domain) {
      const domainParts = domain.split('.');
      setDomain(domainParts[0]);
    }

    dispatch(fetchStyleGuide());
  }, [setDomain]);

  return (
    <AuthPageLayout imageIndex={randomImage} imageText={t('labels.lblWeveHelped')} logo={logo} title={t('others.othDashboardLogin')}>
      <LoginForm />
    </AuthPageLayout>
  );
};

export { LoginPage };
